// extracted by mini-css-extract-plugin
export default {"home":"HomeContenedor_home__MgXuu","carouselWithRadius":"HomeContenedor_carouselWithRadius__VZW0y"};